import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ['form', 'formTemplate', 'formContainer', 'addButton', 'table', 'count', 'hideOnOpenForm'];

  renderForm(event) {
    event && event.preventDefault();
    if (this.hasFormTemplateTarget) {
      this.showForm      = true;
      this.showAddButton = false;
      this.attachFormHandlers();
    } else {
      this.getFormFromServer();
    }
    this.hideOnOpenFormTargets.forEach(t => App.Helpers.hideElement(t));
  }

  closeForm(event) {
    event && event.preventDefault();
    this.showForm      = false;
    this.showAddButton = true;
    this.hideOnOpenFormTargets.forEach(t => App.Helpers.showElement(t));
  }

  replaceFormOnError(event, xhr) {
    this.formContent = xhr.responseText;
    this.attachFormHandlers();
  }

  openEditForm(event) {
    event.preventDefault();
    const link = event.target;
    App.Helpers.ajaxRequest({
      url: link.href,
      method: 'GET',
      successHandler: this.remoteFormHandler.bind(this)
    });
  }

  deleteActivity(event) {
    event.preventDefault();
    const link = event.target;
    if (confirm("Are you sure?")) {
      App.Helpers.ajaxRequest({
        url:            link.href,
        method:         "DELETE",
        data:           {_method: "delete"},
        successHandler: this.emitUpdateSuccess.bind(this)
      });
    }
  }

  //
  // INTERNAL USE
  //

  emitUpdateSuccess() {
    this.closeForm();
    document.dispatchEvent(createCustomEvent("update-success", this.element));
  }

  attachFormHandlers(form=this.formTarget) {
    App.Helpers.addModalHandlers(form);
    App.Helpers.addAjaxHandlers(form, this.emitUpdateSuccess.bind(this), this.replaceFormOnError.bind(this));
  }

  remoteFormHandler(res) {
    App.Modal.open({
      content: `<div data-controller="modal-form" data-modal-form-element-content-from-server="true">${res}</div>`
    });
  }

  getFormFromServer() {
    const url = this.formURL;
    if (url) {
      this.showAddButton = false;
      this.formContent = App.spinner();
      App.Helpers.ajaxRequest({
        url,
        successHandler: (res => {
          this.formContent = res;
          this.attachFormHandlers();
        }).bind(this)
      })
    }
  }

  //
  // GETTERS AND SETTERS
  //

  set showForm(val) {
    if (val && !this.formContainerTarget.innerHTML) {
      this.formContent = this.formTemplateTarget.innerHTML;
    }
    if (!val) this.formContent = '';
  }

  set formContent(val) {
    this.formContainerTarget.innerHTML = val;
  }

  set showAddButton(val) {
    this.addButtonTarget.style.display = val ? 'inline-block' : 'none';
  }

  set activitiesCount(count) {
    this.countTarget.innerHTML = count;
  }

  get tableURL() {
    return this.data.get('table-url');
  }

  get formURL() {
    return this.data.get('form-url');
  }
};



// WEBPACK FOOTER //
// ./app/components/briefs/assets/javascript/brief-association-collection-controller.js